export function logout(action) {
  return {
    type: action.type,
    data: {},
  }
}
